// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".def-index-title[data-v-d0ab7890]{text-align:center}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/Def/DefIndexTitle/DefIndexTitle.vue"],"names":[],"mappings":"AAAA,kCAAiB,iBAEjB","sourcesContent":[".def-index-title{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
